import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  DateRange,
  extractDateRange,
  extractNumber,
  HxCurrencyPipe,
  HxMoneyFormatPipe,
  HxReportService,
  HxUiLabelPipe,
  isoDate,
  ProductCategoryModel,
  StatisticsAbcProductsModel,
  StoreBasicModel,
  toRouterQueryParams
} from 'hx-services';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { subDays, subMonths } from 'date-fns';
import { HxDateRangeSelectComponent, HxLoaderComponent, HxProductCategorySelectComponent, HxStoreSelectComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-abc-products',
    templateUrl: './abc-analysis.component.html',
    styleUrls: ['./abc-analysis.component.css'],
    imports: [HxDateRangeSelectComponent, FormsModule, HxStoreSelectComponent, HxProductCategorySelectComponent, NgIf, NgFor, NgClass, RouterLink, HxLoaderComponent, TranslocoPipe, HxCurrencyPipe, HxUiLabelPipe, HxMoneyFormatPipe]
})
export class AbcAnalysisComponent implements OnInit, OnDestroy {
  sales: StatisticsAbcProductsModel[] = [];
  isloading = {
    sales: false,
  };
  params: {
    date?: DateRange,
    storeId?: number,
    categoryId?: number,
  } = {};
  private sub!: Subscription;

  constructor(
    private reportService: HxReportService,
    private aRoute: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.sub = this.aRoute.queryParamMap.subscribe(async paramMap => {
      this.params.date = extractDateRange('date', paramMap) ?? {from: isoDate(subDays(subMonths(new Date(), 1), 1)), to: isoDate(subDays(new Date(), 1))};
      this.params.categoryId = paramMap.get('categoryId') ? Number(paramMap.get('categoryId')) : undefined;
      this.params.storeId = extractNumber('storeId', paramMap);
      this.loadAbcProducts();
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  applyFilters() {
    this.navigate();
  }

  onCategoryChanged(category: ProductCategoryModel | ProductCategoryModel[] | undefined) {
    if (!Array.isArray(category)){
      this.params.categoryId = category?.id;
      this.applyFilters();
    }
  }

  onStoreChanged(store: StoreBasicModel | StoreBasicModel[] | undefined) {
    if (!Array.isArray(store)){
      this.params.storeId = store?.id;
      this.applyFilters();
    }
  }

  private navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  private async loadAbcProducts() {
    this.sales = [];
    this.isloading.sales = true;
    try {
      const sales = await this.reportService.getStatisticsAbcProductsReport({
        fromDate: this.params.date.from,
        toDate: this.params.date.to,
        categoryId: this.params.categoryId,
        storeIds: [this.params.storeId] });
      if (sales.length > 0) {
        this.sales = sales;
      } else {
        this.sales = [];
      }
    } finally {
      this.isloading.sales = false;
    }
  }
}
